<template>
    <div
        class="bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--main bonusomat-raffle-counters__counter-box--highlighted allwyn-heading-box"
    >
        <div class="allwyn-heading-box__headline">
            <WebpImage
                src="/frontend/web/img/casino/bonusomat/raffle/raffle-joker.svg"
                alt="allwyn žolík"
                class="allwyn-heading-box__logo"
            />
            <div class="allwyn-heading-box__title">Zážitek</div>
        </div>
        <div class="allwyn-heading-box__name" :class="additionalClass" v-html="name"></div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

const props = defineProps<{
    name: string;
}>();

const additionalClass = computed(() => (props.name.length > 25 ? "allwyn-heading-box__name--long" : ""));
</script>
